export default function Header(props) {
  return (
    <header id="header" className="header-tops">
      <div className="container">
        {/* <h1>
          <a href="/">
            <img src="/assets/img/fmi_hd_logo.png" alt="fmi logo" style={{height: "50px"}} className="img-fluid"/>
            <span style={{fontSize: "22px"}}>{props.webTitle}</span>
          </a>
        </h1> */}
        {/* Uncomment below if you prefer to use an image logo */}
        <a href="/" className="d-flex justify-content-center justify-content-lg-start mr-auto">
          <img src="/assets/img/fmi_hd_logo.png" alt="FMI Logo" style={{height: "50px"}} className="img-fluid"/>
        </a>
        <h2>
          <span style={{fontWeight: "bold"}}>
            {props.webTitle}
          </span>
        </h2>

        <nav className="nav-menu d-none d-lg-block">
          <ul>
            <li className="active">
              <a href="#header">
                Home
              </a>
            </li>
            <li>
              <a href="#cotton">
                Cotton
              </a>
            </li>
            <li>
              <a href="#sugar">
                Sugar
              </a>
            </li>

            {/* <li><a href="#resume">Resume</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#portfolio">Portfolio</a></li> */}

            <li>
              <a href="#about">
                {props.aboutText}
              </a>
            </li>
            <li>
              <a href="#contact">
                {props.contactText}
              </a>
            </li>
          </ul>
        </nav>
        {/* .nav-menu */}

        <div className="social-links">
          {/* <a href="#" className="twitter"><i className="icofont-twitter"></i></a>
          <a href="#" className="facebook"><i className="icofont-facebook"></i></a>
          <a href="#" className="instagram"><i className="icofont-instagram"></i></a>
          <a href="#" className="google-plus"><i className="icofont-skype"></i></a>
          <a href="#" className="linkedin"><i className="icofont-linkedin"></i></a> */}

          <a href="https://api.whatsapp.com/send/?phone=923008223858&amp;text=&amp;text=Hi!"
            className="whatsapp"
            target="_blank"
            rel="noreferrer"
          >
            <i className="icofont-brand-whatsapp"></i>
          </a>

          <a href="mailto:support@fundsmi.com" className="email">
            <i className="icofont-envelope"></i>
          </a>
        </div>

      </div>
    </header>
  )
}
